import { ComponentPropsWithRef } from "react"

import { Translate } from "../translate"
import { BaseTypographyProps } from "./types"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type PProps = BaseTypographyProps & ComponentPropsWithRef<"p">

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const P = ({ i18nKey, values, formats, ...props }: PProps) => {
  return (
    <p {...props}>
      <Translate i18nKey={i18nKey} values={values} formats={formats} />
    </p>
  )
}

export { P }
